module.exports = __webpack_public_path__ + "static/media/order-service.e1ad1a84.png";